import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_avmn8_1",
  "details": "_details_avmn8_5",
  "detailsWrapper": "_detailsWrapper_avmn8_11",
  "debug": "_debug_avmn8_18",
  "list": "_list_avmn8_22",
  "main": "_main_avmn8_29",
  "allocation": "_allocation_avmn8_1",
  "infoBubble": "_infoBubble_avmn8_43",
  "slideIn": "_slideIn_avmn8_1",
  "picture": "_picture_avmn8_49",
  "summary": "_summary_avmn8_55",
  "menu": "_menu_avmn8_64",
  "addAllocationIcon": "_addAllocationIcon_avmn8_68",
  "resourcesList": "_resourcesList_avmn8_74",
  "up": "_up_avmn8_81",
  "down": "_down_avmn8_86",
  "quickAllocationMenu": "_quickAllocationMenu_avmn8_92",
  "overlay": "_overlay_avmn8_97"
};